import { Outlet } from 'react-router'
import { TaskOverlay } from '@/player/TaskOverlay'
import { TourOverlay } from '@/player/TourOverlay'
import { useIdentityInUrl } from '@/session/identity-url'
import { AccessibilityTour } from '@/tour/AccessibilityTour'
import { AppTour } from '@/tour/AppTour'
import { PracticeModeBar } from '@/ui/practice-mode-bar'

/**
 * Layout route wrapping every screen so the lesson players can sit above the
 * real app rather than re-implementing each screen inside the player.
 *
 * Both players are mounted unconditionally and both are inert until their own
 * URL parameter appears `?tour=` for the guided coach marks, `?sim=` for the
 * unguided checklist. They are mutually exclusive in practice, but neither
 * knows about the other, so a lesson cannot get into a half-guided state.
 *
 * It is also where `?EmployeeId=&Role=` is kept alive on the URL. This is the
 * only element wrapping every route, so it is the one place that sees every
 * navigation and identity has to survive a reload or completions are
 * silently recorded local-only. See `@/session/identity-url`.
 */
export function TourLayout() {
  useIdentityInUrl()

  return (
    <div className="flex flex-col h-full">
      <PracticeModeBar />
      <div className="flex-1 min-h-0 relative overflow-hidden">
        <Outlet />
        <TourOverlay />
        <TaskOverlay />
        <AppTour />
        <AccessibilityTour />
      </div>
    </div>
  )
}
